document.addEventListener('DOMContentLoaded', () => {
  const doctorProfiles = document.querySelectorAll('.clinic-doctors__doctor-profile');
  const popupContainer = document.querySelector('.clinic-doctors__popup-doctor-info');
  const popupDoctors = document.querySelectorAll('.clinic-doctors__popup-content-doctor-info');

  // Handle view profile button click
  doctorProfiles.forEach(profile => {
    profile.addEventListener('click', e => {
      if (e.target.classList.contains('clinic-doctors__view-profile-btn')) {
        const drName = profile.getAttribute('data-dr-name');
        const loopIndex = profile.getAttribute('data-loop-index');

        // Show popup container
        popupContainer.classList.add('active');
        document.body.classList.add('overflow-hidden')

        // Show specific popup
        popupDoctors.forEach(popup => {
          const popupDrName = popup.getAttribute('data-dr-name');
          const popupLoopIndex = popup.getAttribute('data-loop-index');

          if (popupDrName === drName || popupLoopIndex === loopIndex) {
            popup.style.display = 'block'; // Or add a CSS class if preferred
          } else {
            popup.style.display = 'none';
          }
        });
      }
    });
  });

  // Close popup when clicking outside or on close button
  popupContainer.addEventListener('click', e => {
    if (e.target === popupContainer || e.target.closest('.hero-banner-slider__contact-popup-close')) {
      popupContainer.classList.remove('active');
      document.body.classList.remove('overflow-hidden')
      popupDoctors.forEach(popup => (popup.style.display = 'none'));
    }
  });
});
